import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { setAuth, isAuthenticated } from '@stores/authStore';
import { api } from '@services/api';

export function LoginPage() {
  const [isRegister, setIsRegister] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);

  useEffect(() => {
    // If already logged in, redirect to dashboard
    if (isAuthenticated.value) {
      route('/dashboard');
    }
  }, []);

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const endpoint = isRegister ? '/api/auth/register' : '/api/auth/login';
    const payload = isRegister ? { name, email, password } : { email, password };

    const response = await api.post<any>(endpoint, payload);

    if (response.success) {
      if (isRegister && response.data?.requiresVerification) {
        // Registration successful, show verification message
        setRegistrationSuccess(true);
      } else if (response.data?.access_token) {
        // Login successful
        setAuth(response.data.access_token, response.data.user);
        route('/dashboard');
      }
    } else {
      setError(response.error || (isRegister ? '회원가입 실패' : '로그인 실패'));
    }

    setLoading(false);
  };

  return (
    <div class="flex min-h-screen items-center justify-center bg-gray-100">
      <div class="card w-full max-w-md">
        <div class="mb-6 flex flex-col items-center">
          <img src="/logo.svg" alt="DbitLabs Logo" class="mb-3 h-16 w-16" />
          <h1 class="font-brand text-center text-2xl font-bold">DbitLabs : IssueManager</h1>
        </div>

        {registrationSuccess ? (
          <div class="text-center">
            <div class="mb-4 rounded bg-green-100 p-4 text-green-700">
              <p class="font-medium">회원가입이 완료되었습니다!</p>
              <p class="mt-2 text-sm">
                입력하신 이메일로 인증 링크를 발송했습니다.<br />
                이메일을 확인하여 인증을 완료해주세요.
              </p>
            </div>
            <button
              onClick={() => {
                setRegistrationSuccess(false);
                setIsRegister(false);
                setName('');
                setEmail('');
                setPassword('');
              }}
              class="btn btn-primary text-white"
            >
              로그인 페이지로 이동
            </button>
          </div>
        ) : (
          <>
            <div class="mb-6 flex gap-2">
              <button
                onClick={() => setIsRegister(false)}
                class={`flex-1 rounded px-4 py-2 font-medium ${
                  !isRegister ? 'bg-primary-600 text-white' : 'bg-gray-200 text-gray-700'
                }`}
              >
                로그인
              </button>
              <button
                onClick={() => setIsRegister(true)}
                class={`flex-1 rounded px-4 py-2 font-medium ${
                  isRegister ? 'bg-primary-600 text-white' : 'bg-gray-200 text-gray-700'
                }`}
              >
                회원가입
              </button>
            </div>

            <form onSubmit={handleSubmit}>
          {isRegister && (
            <div class="mb-4">
              <label class="mb-2 block text-sm font-medium text-gray-700">이름</label>
              <input
                type="text"
                class="input"
                value={name}
                onInput={(e) => setName((e.target as HTMLInputElement).value)}
                required
                minLength={2}
              />
            </div>
          )}

          <div class="mb-4">
            <label class="mb-2 block text-sm font-medium text-gray-700">이메일</label>
            <input
              type="email"
              class="input"
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
              required
            />
          </div>

          <div class="mb-4">
            <label class="mb-2 block text-sm font-medium text-gray-700">비밀번호</label>
            <input
              type="password"
              class="input"
              value={password}
              onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
              required
              minLength={8}
            />
            {isRegister && (
              <p class="mt-1 text-xs text-gray-500">
                최소 8자, 대문자, 소문자, 숫자 포함
              </p>
            )}
          </div>

          {error && (
            <div class="mb-4 rounded bg-red-100 p-3 text-sm text-red-700">{error}</div>
          )}

          <button type="submit" class="btn btn-primary w-full" disabled={loading}>
            {loading ? '처리중...' : isRegister ? '회원가입' : '로그인'}
          </button>

          {!isRegister && (
            <div class="mt-4 text-center">
              <a
                href="/forgot-password"
                class="text-sm text-gray-600 hover:text-primary-600 hover:underline"
              >
                비밀번호를 잊으셨나요?
              </a>
            </div>
          )}
            </form>
          </>
        )}
      </div>
    </div>
  );
}
